import {
  Component,
  ElementRef,
  NgZone,
  OnInit,
  OnDestroy,
  ViewChild
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationEnd, RouterOutlet } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { LoadingBarModule } from '@ngx-loading-bar/core';
import {MatSidenavModule} from '@angular/material/sidenav';

import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { CommonModule } from '@angular/common';

const SMALL_WIDTH_BREAKPOINT = 991;

export interface Options {
  heading?: string;
  removeFooter?: boolean;
}

@Component({
    selector: 'app-admin',
    templateUrl: './admin-layout.component.html',
    styleUrls: ['./admin-layout.component.scss'],
    imports: [CommonModule, RouterOutlet, MatSidenavModule, LoadingBarModule, HeaderComponent, SidebarComponent, FooterComponent]
})
//

export class AdminLayoutComponent implements OnInit, OnDestroy {
  private _router: Subscription  = {} as Subscription;
  private mediaMatcher: MediaQueryList = matchMedia(
    `(max-width: ${SMALL_WIDTH_BREAKPOINT}px)`
  );

  isMobile = false; // Added property for mobile detection
  routeOptions: Options = {} as Options;

  options = {
    lang: 'en',
    theme: 'winter',
    settings: false,
    docked: false,
    boxed: false,
    opened: false
  };

  currentLang = 'en';

  @ViewChild('sidebar') sidebar : any;
  @ViewChild('sidemenu') sidemenu :  any;

  constructor(
    private _element: ElementRef,
    private router: Router,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private titleService: Title,
    zone: NgZone
  ) {
    this.mediaMatcher.addListener(mql =>
      zone.run(() => {
        //this.mediaMatcher = mql;
      })
    );
  }

  ngOnInit(): void {
    // Check if mobile on init
    this.checkScreenSize();
    
    // Listen for window resize events
    window.addEventListener('resize', this.checkScreenSize.bind(this));
    
    this._router = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Scroll to top on view load
        document.querySelector('.main-content').scrollTop = 0;
        if (this.isOver()) {
          this.sidemenu.close();
        }
        this.runOnRouteChange();
      });

    this.runOnRouteChange();
  }
  
  /**
   * Check screen size and set mobile flag
   * This function is called on init and window resize
   */
  checkScreenSize(): void {
    const wasAlreadyMobile = this.isMobile;
    this.isMobile = window.innerWidth < SMALL_WIDTH_BREAKPOINT;
    
    // If changed from desktop to mobile, ensure sidenav is closed
    if (!wasAlreadyMobile && this.isMobile && this.sidemenu) {
      setTimeout(() => {
        this.sidemenu.close();
      }, 100);
    }
  }

  ngOnDestroy() {
    this._router.unsubscribe();
    // Remove resize event listener
    window.removeEventListener('resize', this.checkScreenSize.bind(this));
  }

  runOnRouteChange(): void {
    this.route.children.forEach((route: ActivatedRoute) => {
      let activeRoute: ActivatedRoute = route;
      while (activeRoute.firstChild) {
        activeRoute = activeRoute.firstChild;
      }
      this.routeOptions = activeRoute.snapshot.data;
    });

    if (this.routeOptions.hasOwnProperty('heading')) {
      this.setTitle(this.routeOptions.heading as string);
    }
  }

  setTitle(newTitle: string) {
    this.titleService.setTitle(
      'CORE-APP | ' + newTitle
    );
  }

  isOver(): boolean {
    return this.mediaMatcher.matches || this.isMobile;
  }

  receiveMessage($event : any) {
    this.options = $event;
  }

  toggleFullscreen(): void {
    const elem = this._element.nativeElement.querySelector('.main-content');
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullScreen) {
      elem.webkitRequestFullScreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.msRequestFullScreen) {
      elem.msRequestFullScreen();
    }
  }

  /**
   * Close sidenav when menu item is clicked on mobile
   */
  onMenuClick(): void {
    if (this.isOver()) {
      this.sidemenu.close();
    }
  }
}
